import React, { useState } from 'react'
import { format, parse, setHours, setMinutes, differenceInMinutes } from 'date-fns'
import TimeSelectOptions from './TimeSelectOptions'

export default function Timeslot ({ index, startAt, duration, endAt }) {
  const [values, setValues] = useState({ startAt: startAt, duration: duration, endAt: endAt })

  const parseTimeString = (timeStr) => {
    // Parse time string like "9:00 am" into hours and minutes
    const parsed = parse(timeStr, 'h:mm aaa', new Date())
    return { hours: parsed.getHours(), minutes: parsed.getMinutes() }
  }

  const startAtChanged = event => {
    let startTimeStr = event.target.value

    if (startTimeStr) {
      const { hours, minutes } = parseTimeString(startTimeStr)
      let updatedStartAt = setMinutes(setHours(values.endAt, hours), minutes)

      return setValues(values => ({ ...values, startAt: updatedStartAt, duration: calculateDuration(updatedStartAt, values.endAt) }))
    }
  }

  const endAtChanged = event => {
    let endTimeStr = event.target.value

    if (endTimeStr) {
      const { hours, minutes } = parseTimeString(endTimeStr)
      let updatedEndAt = setMinutes(setHours(values.endAt, hours), minutes)

      return setValues(values => ({ ...values, endAt: updatedEndAt, duration: calculateDuration(values.startAt, updatedEndAt) }))
    }
  }

  const calculateDuration = (startAt, endAt) => {
    return differenceInMinutes(endAt, startAt)
  }

  let inputName = attribute => `event[custom_timeslots][][${attribute}]`

  let inputValue = format(values.startAt, 'MMMM d, yyyy h:mm aaa')

  return (
    <li className='list-group-item border-0 border-bottom'>
      <div className='row'>
        <div className='col-1 p-2'>{`Session ${index}`}</div>
        <div className='col-3 p-2'>
          {format(values.startAt, 'EEE MMMM d, yyyy')}
        </div>
        <div className='col-2'>
          <select name='start_time' value={format(values.startAt, 'h:mm aaa')} onChange={startAtChanged} className='form-control'>
            <TimeSelectOptions />
          </select>
          <input name={inputName('start_at')} type='hidden' value={inputValue} />
        </div>
        <div className='col-2'>
          <select name='end_time' value={format(values.endAt, 'h:mm aaa')} onChange={endAtChanged} className='form-control'>
            <TimeSelectOptions />
          </select>
        </div>
        <input name={inputName('duration')} type='hidden' value={values.duration} />
      </div>
    </li>
  )
}
